import { ReactComponent as IconAddAsset } from "../HomeExplorer/assets/icon-add-asset.svg";
import { ReactComponent as IconAddBot } from "../HomeExplorer/assets/icon-add-bot.svg";
import { ReactComponent as IconAddContact } from "../HomeExplorer/assets/icon-add-contact.svg";
import { ReactComponent as IconAddEvent } from "../HomeExplorer/assets/icon-add-event.svg";
import { ReactComponent as IconAddFolder } from "../HomeExplorer/assets/icon-add-folder.svg";
import { ReactComponent as IconAddTable } from "../HomeExplorer/assets/icon-add-table.svg";
import { ReactComponent as IconAddWorkflow } from "../HomeExplorer/assets/icon-add-workflow.svg";
import { ReactComponent as IconBots } from "../HomeExplorer/assets/icon-bots.svg";
import { ReactComponent as IconCalendar } from "../HomeExplorer/assets/icon-calendar.svg";
import { ReactComponent as IconChats } from "../HomeExplorer/assets/icon-chats.svg";
import { ReactComponent as IconConf } from "../HomeExplorer/assets/icon-conf.svg";
import { ReactComponent as IconContact } from "../HomeExplorer/assets/icon-contact.svg";
import { ReactComponent as IconDocument } from "../HomeExplorer/assets/icon-document.svg";
import { ReactComponent as IconExploreCommunity } from "../HomeExplorer/assets/icon-explore-community.svg";
import { ReactComponent as IconAsset } from "../HomeExplorer/assets/icon-asset.svg";
import { ReactComponent as IconHelp } from "../HomeExplorer/assets/icon-help.svg";
import { ReactComponent as IconMore } from "../HomeExplorer/assets/icon-more.svg";
import { ReactComponent as IconPanel } from "../HomeExplorer/assets/icon-panel.svg";
import { ReactComponent as IconStar } from "../HomeExplorer/assets/icon-star.svg";
import { ReactComponent as IconSuggestion } from "../HomeExplorer/assets/icon-suggestion.svg";
import { ReactComponent as IconTable } from "../HomeExplorer/assets/icon-table.svg";
import { ReactComponent as IconTables } from "../HomeExplorer/assets/icon-tables.svg";
import { ReactComponent as IconTransaction } from "../HomeExplorer/assets/icon-transaction.svg";
import { ReactComponent as IconUpload } from "../HomeExplorer/assets/icon-upload.svg";
import { ReactComponent as IconWorkflows } from "../HomeExplorer/assets/icon-workflows.svg";
import { ReactComponent as IconAddTransaction } from "../HomeExplorer/assets/icon-add-transaction.svg";
import { ReactComponent as IconWorkspace } from "../HomeExplorer/assets/icon-workspace.svg";
import { ReactComponent as IconDoc } from "../HomeExplorer/assets/icon-doc.svg";
import { ReactComponent as IconAddChat } from "../HomeExplorer/assets/icon-add-chat.svg";



export const menuOptions = [
    {
        icon: <IconPanel />,
        title: "Panel Documentos",
        description: "Gestiona y visualiza todos tus documentos en un panel centralizado",
        href: "/panel"
    },
    {
        icon: <IconTransaction />,
        title: "Panel Income and Expenses",
        description: "Controla tus ingresos y gastos con análisis detallados",
        href: "/panel"
    },
    {
        icon: <IconAddWorkflow />,
        title: "Workflow crear uno nuevo",
        description: "Crea un nuevo flujo de trabajo automatizado desde cero",
        href: "/workflow"
    },
    {
        icon: <IconWorkflows />,
        title: "Workflow importar todos",
        description: "Importa workflows existentes desde archivos externos",
        href: "/workflow"
    },
    {
        icon: <IconAddBot />,
        title: "bot crear uno nuevo",
        description: "Crea un nuevo bot personalizado para automatizar tareas",
        href: "/bots"
    },
    {
        icon: <IconBots />,
        title: "ir al marketplace",
        description: "Explora bots y herramientas disponibles en el marketplace",
        href: "/bots"
    },
    {
        icon: <IconChats />,
        title: "chat ir al chat",
        description: "Accede a la conversación con el asistente AI",
        href: "/chat"
    },
    {
        icon: <IconAddChat />,
        title: "chat ir al chat",
        description: "Inicia una nueva conversación o continúa una existente",
        href: "/chat"
    },
    {
        icon: <IconDoc />,
        title: "chatir al chat más usado",
        description: "Accede rápidamente al chat más frecuentemente utilizado",
        href: "/docs"
    },
    {
        icon: <IconAddChat />,
        title: "chat algonuevo",
        description: "Crea un nuevo chat con funcionalidades avanzadas",
        href: "/calendar"
    },
    {
        icon: <IconDocument />,
        title: "Nuevo documento",
        description: "Crea un nuevo documento desde una plantilla o en blanco",
        href: "/new-documento"
    },
    {
        icon: <IconUpload />,
        title: "Subir archivo",
        description: "Sube archivos desde tu dispositivo para procesarlos",
        href: "/upload-file"
    },
    {
        icon: <IconAddTable />,
        title: "Nueva tabla",
        description: "Crea una nueva tabla para organizar datos y información",
        href: "/upload-file"
    },
    {
        icon: <IconAddFolder />,
        title: "Nueva carpeta",
        description: "Organiza tus archivos creando una nueva carpeta",
        href: "/upload-file"
    },
    {
        icon: <IconAddContact />,
        title: "Nuevo contacto",
        description: "Añade un nuevo contacto a tu agenda de clientes",
        href: "/upload-file"
    },
    {
        icon: <IconAddAsset />,
        title: "Nuevo asset",
        description: "Registra un nuevo activo o producto en tu inventario",
        href: "/upload-file"
    },
    {
        icon: <IconAddChat />,
        title: "Nuevo chat",
        description: "Inicia una nueva conversación con el asistente AI",
        href: "/upload-file"
    },
    {
        icon: <IconAddWorkflow />,
        title: "Nuevo workflow",
        description: "Diseña un nuevo flujo de trabajo automatizado",
        href: "/upload-file"
    },
    {
        icon: <IconAddEvent />,
        title: "Nuevo evento",
        description: "Programa un nuevo evento o recordatorio en el calendario",
        href: "/upload-file"
    },
    {
        icon: <IconExploreCommunity />,
        title: "Explorar comunidad",
        description: "Descubre recursos y herramientas de la comunidad",
        href: "/upload-file"
    },
    {
        icon: <IconStar />,
        title: "Get plus",
        description: "Actualiza tu plan para acceder a funcionalidades premium",
        href: "/upload-file"
    },
    {
        icon: <IconConf />,
        title: "Ajustes",
        description: "Configura las preferencias generales de tu cuenta",
        href: "/upload-file"
    },
    {
        icon: <IconConf />,
        title: "Ajustes",
        description: "Personaliza la configuración de tu perfil de usuario",
        href: "/upload-file"
    },
    {
        icon: <IconConf />,
        title: "Ajustes",
        description: "Gestiona la configuración de seguridad y privacidad",
        href: "/upload-file"
    },
    {
        icon: <IconConf />,
        title: "Ajustes",
        description: "Configura las opciones de notificaciones y alertas",
        href: "/upload-file"
    },
    {
        icon: <IconConf />,
        title: "Ajustes",
        description: "Personaliza la apariencia y tema de la aplicación",
        href: "/upload-file"
    },
    {
        icon: <IconHelp />,
        title: "Help center",
        description: "Accede a la documentación y guías de uso",
        href: "/upload-file"
    },
    {
        icon: <IconHelp />,
        title: "Help center",
        description: "Encuentra respuestas a preguntas frecuentes",
        href: "/upload-file"
    },
    {
        icon: <IconHelp />,
        title: "Help center",
        description: "Contacta con soporte técnico para obtener ayuda",
        href: "/upload-file"
    },
    {
        icon: <IconSuggestion />,
        title: "Send sugestion",
        description: "Envía sugerencias para mejorar la plataforma",
        href: "/upload-file"
    },
    
]